// @ts-ignore
import colors from "css/variables/_colors.scss"
import React, { FC, HTMLAttributes } from "react"
import { SharedInputCssProps, StyledSelect } from "./StyledInputs"
import { SinglePathSVG } from "../../SVG"
import { completeFormElementFactory, CompleteFormElementProps } from "./completeFormElementFactory"

export type FormSelectProps = {
  placeholderText?: string
  options: OptionProps[]
} & Partial<SharedInputCssProps> &
  HTMLAttributes<HTMLSelectElement>

const FormSelect = React.forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ options, valid = true, placeholderText = "Select", ...props }: FormSelectProps, ref) => {
    return (
      <div className="relative">
        <StyledSelect {...props} valid={valid} ref={ref} defaultValue="">
          <option disabled value="" className="placeholder">
            {placeholderText}
          </option>
          {options.map((option) => (
            <Option key={option.id} {...option} />
          ))}
        </StyledSelect>
        <div className="absolute top-0 right-0 h-100 flex flex-row items-center pa2-ns pa1 no-pointer-events">
          <div className="ph3 black-40">
            <SinglePathSVG icon="down" fill={colors.carrotOrange} />
          </div>
        </div>
      </div>
    )
  }
)

FormSelect.displayName = "FormSelect"

type OptionProps = {
  id: string
  label: string
}

const Option: FC<OptionProps> = ({ id, label }) => (
  <option value={id} label={label}>
    {label}
  </option>
)

const CompleteFormSelect = completeFormElementFactory<
  HTMLSelectElement,
  CompleteFormElementProps<HTMLSelectElement> & FormSelectProps
>(FormSelect)

export { CompleteFormSelect, FormSelect }
